import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import Progress from './Progress';

export default function CustomButton(props) {
  return (
    <div className="relative">
      <Button
        variant="contained"
        color="primary"
        className={`rounded ${props.className}`}
        fullWidth
        size="large"
        disabled={props.disabled}
        onClick={() => {
          props.handler ? props.handler() : {};
        }}
      >
        {props.name}
      </Button>
      <Progress
        style={{
          position: 'absolute',
          top: 'calc(50% - 8px)',
          bottom: 0,
          right: 15,
          ...props.progressStyle,
        }}
        show={props.progressShow}
      />
    </div>
  );
}
CustomButton.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  handler: PropTypes.func,
  progressStyle: PropTypes.object,
  progressShow: PropTypes.bool,
};
